import { accountClient } from '@/api';
import { defineStore } from 'pinia';
import { StoreAccessRol } from '../types/storeAccessRol.type';
import { AccessRolAction, AccessRolSection } from '../types/accessRol';

export const useAccessRolStore = defineStore('accessRol', {
  state: (): StoreAccessRol => ({
    accessRol: [],
    isLoading: false,
    isLoaded: false,
  }),
  getters: {
    isReady: (state) =>
      state.isLoaded && !state.isLoading && state.accessRol.length > 0,
    hasAccess:
      (state) =>
      (
        section: AccessRolSection,
        actions?: AccessRolAction[]
      ) => {
        if (!state.isLoaded || state.isLoading) return false;
        if (!Array.isArray(actions) || !actions?.length) return true;

        const sectionData = state.accessRol.find((r) => r.section === section);
        if (!sectionData) return false;

        return actions?.some((action) => sectionData.actions.includes(action));
      },
  },
  actions: {
    async getAccessRol(force = false) {
      try {
        if ((this.isLoaded || this.isLoading) && !force) return;

        this.isLoading = true;

        const { data } = await accountClient.getAccessRol();
        this.accessRol = data;

        this.isLoaded = true;
      } catch (error) {
        this.accessRol = [];
        this.isLoaded = false;
      } finally {
        this.isLoading = false;
      }
    },
    resetAccessRol() {
      this.accessRol = [];
      this.isLoading = false;
      this.isLoaded = false;
    },
  },
});
